module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#f9f9f9",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "goods_cate",
    staticStyle: {
      "width": "1240px",
      "margin": "0 auto"
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, _vm._l((_vm.breadData), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": item.path
      }
    }, [_c('a', [_vm._v(_vm._s(item.name))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "navCon wrapper_1200 acea-row row-between-wrapper"
  }, [_c('div', {
    staticClass: "list  row-middle",
    staticStyle: {}
  }, [_c('el-tabs', {
    model: {
      value: (_vm.topCateId),
      callback: function($$v) {
        _vm.topCateId = $$v
      },
      expression: "topCateId"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "0"
    }
  }), _vm._v(" "), _vm._l((_vm.cateTree), function(cvalue, cindex) {
    return _c('el-tab-pane', {
      key: cindex,
      attrs: {
        "label": cvalue.name,
        "name": cvalue.id + ''
      }
    })
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper_1200"
  }, [(_vm.cateList.length > 0) ? _c('div', {
    staticClass: "acea-row"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("分类：")]), _vm._v(" "), _c('div', {
    staticClass: "listCon acea-row row-between"
  }, [_c('div', {
    staticClass: "list acea-row row-middle",
    class: _vm.sortNav ? '' : 'on'
  }, [_c('div', {
    key: -1,
    staticClass: "item",
    class: _vm.subCateId == _vm.topCateId ? 'font-color' : '',
    on: {
      "click": function($event) {
        return _vm.onCateChange(_vm.topCateId, 0)
      }
    }
  }, [_vm._v("\n              全部\n            ")]), _vm._v(" "), _vm._l((_vm.cateList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: _vm.subCateId == (item.id) ? 'font-color' : '',
      on: {
        "click": function($event) {
          return _vm.onCateChange(item.id, index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sort acea-row"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("排序：")]), _vm._v(" "), _c('div', {
    staticClass: "acea-row row-middle"
  }, [_c('div', {
    staticClass: "item",
    class: 'font-color',
    on: {
      "click": _vm.defaults
    }
  }, [_vm._v("\n            默认 \n          ")]), _vm._v(" "), (_vm.priceOrder === 'asc') ? _c('div', {
    staticClass: "item",
    class: _vm.iSdefaults === 1 ? 'font-color' : '',
    on: {
      "click": function($event) {
        return _vm.priceSort('desc')
      }
    }
  }, [_vm._v("\n            价格\n            "), _c('span', {
    staticClass: "iconfont icon-jiageshaixuanshang"
  })]) : (_vm.priceOrder === '') ? _c('div', {
    staticClass: "item",
    class: _vm.iSdefaults === 1 ? 'font-color' : '',
    on: {
      "click": function($event) {
        return _vm.priceSort('asc')
      }
    }
  }, [_vm._v("\n            价格\n            "), _c('span', {
    staticClass: "iconfont icon-jiageshaixuan"
  })]) : _c('div', {
    staticClass: "item",
    class: _vm.iSdefaults === 1 ? 'font-color' : '',
    on: {
      "click": function($event) {
        return _vm.priceSort('')
      }
    }
  }, [_vm._v("\n            价格\n            "), _c('span', {
    staticClass: "iconfont icon-jiageshaixuanxia"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: '',
    on: {
      "click": _vm.timeNews
    }
  }, [_vm._v("\n            上架时间\n            "), _c('span', {
    staticClass: "iconfont icon-shangjiashijian",
    class: ''
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "cmsdetail"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [(this.noticeData.length) ? _c('el-alert', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": this.noticeData[0].title,
      "type": "warning",
      "description": this.noticeData[0].desc
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "goods-cate-box"
  }, [_c('div', {
    class: _vm.cate_index == 0 ? 'goods-cate goods-cate-active' : 'goods-cate',
    on: {
      "click": function($event) {
        return _vm.onCateChange(0, -1)
      }
    }
  }, [_vm._v("\n          全部\n        ")]), _vm._v(" "), _vm._l((_vm.cateList), function(item, i) {
    return _c('div', {
      key: i,
      class: _vm.cate_index == i + 1 ? 'goods-cate goods-cate-active' : 'goods-cate',
      on: {
        "click": function($event) {
          return _vm.onCateChange(item.id, i)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "goods-main-box"
  }, _vm._l((_vm.list), function(item, x) {
    return _c('div', {
      key: x,
      staticClass: "goods-items",
      on: {
        "click": function($event) {
          return _vm.onGoodsDetail(item.id)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.pic_url),
        expression: "item.pic_url"
      }],
      attrs: {
        "alt": "",
        "srcset": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p1"
    }, [_c('span', {
      staticClass: "goods-items-span1"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("¥")]), _vm._v("\n              " + _vm._s(item.price_range[0]) + "\n              "), _c('span', {
      staticClass: "span1-span",
      staticStyle: {
        "text-decoration": "line-through",
        "color": "#999",
        "margin-left": "10px"
      }
    }, [_vm._v("¥" + _vm._s(item.orig_price))])]), _vm._v(" "), _c('span', {
      staticClass: "goods-items-span2"
    }, [_vm._v("已售出" + _vm._s(item.sold_count + item.sold_show_count))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "p1"
    }, [_c('span', {
      staticClass: "goods-items-span2"
    }, [_vm._v("\n               " + _vm._s(item.sold_count + item.sold_show_count) + "人付款购买\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "goods-items-span2"
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f55a3ae2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/GoodsList.vue
// module id = 1341
// module chunks = 0